var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "read"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 9.94422H6.20007C6.85673 9.94422 7.46086 10.1848 7.93919 10.5861L7.99587 1.89701C7.99509 0.85072 7.1898 0 6.2002 0L0.632925 0C0.28339 0 0 0.299665 0 0.669275L0 9.94422ZM1.92018 2.25867L5.85222 2.25867C6.13055 2.25867 6.3561 2.4973 6.3561 2.79162C6.3561 3.08594 6.13055 3.32457 5.85222 3.32457L1.92018 3.32457C1.64184 3.32457 1.41617 3.08594 1.41617 2.79162C1.41617 2.4973 1.64184 2.25867 1.92018 2.25867ZM1.92018 4.43916H5.85222C6.13055 4.43916 6.3561 4.6778 6.3561 4.97211C6.3561 5.26643 6.13055 5.50493 5.85222 5.50493H1.92018C1.64184 5.50493 1.41617 5.26643 1.41617 4.97211C1.41617 4.6778 1.64184 4.43916 1.92018 4.43916ZM1.92018 6.61965H5.85222C6.13055 6.61965 6.3561 6.85829 6.3561 7.15247C6.3561 7.44678 6.13055 7.68542 5.85222 7.68542H1.92018C1.64184 7.68542 1.41617 7.44678 1.41617 7.15247C1.41617 6.85829 1.64184 6.61965 1.92018 6.61965Z",
    fill: "#5A608D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.00414 10.6343C9.49089 10.2038 10.1172 9.94422 10.7999 9.94422H17V0.669275C17 0.299665 16.7166 0 16.3671 0L10.7998 0C9.808 0 9.00414 0.850172 9.00414 1.89879V10.6343ZM11.1478 2.25867L15.0798 2.25867C15.3582 2.25867 15.5838 2.4973 15.5838 2.79162C15.5838 3.08594 15.3582 3.32457 15.0798 3.32457L11.1478 3.32457C10.8694 3.32457 10.6439 3.08594 10.6439 2.79162C10.6439 2.4973 10.8694 2.25867 11.1478 2.25867ZM11.1478 4.43916H15.0798C15.3582 4.43916 15.5838 4.6778 15.5838 4.97211C15.5838 5.26643 15.3582 5.50493 15.0798 5.50493H11.1478C10.8694 5.50493 10.6439 5.26643 10.6439 4.97211C10.6439 4.6778 10.8694 4.43916 11.1478 4.43916ZM11.1478 6.61965H15.0798C15.3582 6.61965 15.5838 6.85829 15.5838 7.15247C15.5838 7.44678 15.3582 7.68542 15.0798 7.68542H11.1478C10.8694 7.68542 10.6439 7.44678 10.6439 7.15247C10.6439 6.85829 10.8694 6.61965 11.1478 6.61965Z",
    fill: "#5A608D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.20007 10.6338H0L0 11.3304C0 11.7001 0.28339 11.9998 0.632925 11.9998H7.92389C7.70547 11.2113 7.01535 10.6338 6.20007 10.6338Z",
    fill: "#5A608D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.07471 11.9998H16.3655C16.7152 11.9998 16.9985 11.7 16.9985 11.3304V10.6338H10.7985C9.98325 10.6338 9.29313 11.2113 9.07471 11.9998Z",
    fill: "#5A608D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.535eb7ea.svg";
export { ForwardRef as ReactComponent };